<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Recover Password" />
            <RecoverPassword />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import RecoverPassword from '../RecoverPassword/RecoverPassword'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'RecoverPasswordPage',
    components: {
        NavBar,
        PageTitle,
        RecoverPassword,
        FooterComp,
    }
}
</script>